import React from 'react';
import images from '../../images';
import { logout } from '../../api/auth.sso';
import useAuth from '../../hooks/useAuth';

const ProfileUpper = ({loading, userData }) => {
  const { logout: contextLogout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      contextLogout();
    } catch (error) {
      console.error('Ошибка при выходе:', error);
    }
  };

  return (
    <div className="profile-upper">
      <div className="profile-image-container">
        <img
          src={images.userProfile}
          alt="Аватар"
          className="profile-image"
        />
      </div>
      <div className="profile-info-user">
        <div className="profile-ids">
          <div className="profile-id">ID: {loading? 'Загрузка...' : userData.id}</div>
          <div className="profile-short-name">{loading? 'Загрузка...' : userData.upk}</div>
        </div>

        <div className="profile-full-name">{loading? 'Загрузка...' : userData.name}</div>

        <div className="profile-email">
          <img
            src={images.letter}
            alt=""
            className="profile-email-icon"
          />
          {loading? 'Загрузка...' : userData.email}
        </div>

        <button
          className="profile-logout-button"
          onClick={handleLogout}
        >
          <img src={images.exitLinear} alt="" className="profile-logout-icon"/>
          <span className="profile-logout-text">Выйти из аккаунта</span>
        </button>
      </div>
    </div>
  );
};

export default ProfileUpper;
